module.exports = __webpack_public_path__ + "static/media/caricom-flag.ef82c6b9.svg";